(function () {
  'use strict';

  angular.module('ringbaPortal')
    .component('forgotPasswordV2', {
      controller: ForgotPasswordV2Controller,
      controllerAs: 'vm',
      templateUrl: '/scripts/components/auth/v2/forgot-passwordv2.view.html'
    });

  function ForgotPasswordV2Controller(
    $q,
    $state,
    $stateParams,
    authService,
    cacheService,
    utils,
    whitelabelService
  ) {

    const vm = this;
    vm.wlAccountId = undefined;
    vm.isWhitelabeledSite = false;

    vm.resetEmail = null;

    vm.$onInit = onInit;

    function onInit() {
      _checkPreviewMode();

      vm.fetchingWlSettings = true;
      _getWlAccountId().then(function(accountId) {
        vm.wlAccountId = accountId;
      }).finally(function () {
        vm.fetchingWlSettings = false;
      });
      vm.isWhitelabeledSite = !whitelabelService.checkLocationHostIsBase() || $stateParams.preview == 'true';
    }

    function _getWlAccountId() {
      _resetHostData();
      if (whitelabelService.checkLocationHostIsBase()) {
        return $q.when(undefined);
      } else {
        return whitelabelService.getPublicWlSettings({ timeout: 5000 }).then(function (response) {
          return response.data && response.data.accountId;
        });
      }
    }

    function _checkPreviewMode() {
      if ($stateParams.preview) {
        vm.previewModeEnabled = true;
        vm.currentTheme = cacheService.get('forgot-password-preview');
        vm.isLightTheme = vm.currentTheme.isLightTheme;
        cacheService.remove('forgot-password-preview');
      }
    }

    function _resetHostData() {
      vm.wlAccountId = undefined;
    }
  }
})();
